// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","banner":"_4uzl4","content":"_1O3Eh","bannerTitle":"_2qTDx","bannerDescription":"rHYAs","hidden":"_1_x-L"};